export const STORE_DATA_CRAFTER_TEMPLATES = 'dataCrafterTemplates';
export const STORE_DATA_CRAFTER_TEMPLATE_FORM = 'dataCrafterTemplateForm';
export const STORE_DATA_CRAFTER_SCRIPT_COMPILATION = 'dataCrafterScriptCompilation';
export const STORE_DATA_CRAFTER_OUTPUT_VARIANTS = 'dataCrafterOutputVariants';

export type STORE_DATA_CRAFTER_TEMPLATES = typeof STORE_DATA_CRAFTER_TEMPLATES;
export type STORE_DATA_CRAFTER_TEMPLATE_FORM = typeof STORE_DATA_CRAFTER_TEMPLATE_FORM;
export type STORE_DATA_CRAFTER_SCRIPT_COMPILATION = typeof STORE_DATA_CRAFTER_SCRIPT_COMPILATION;
export type STORE_DATA_CRAFTER_OUTPUT_VARIANTS = typeof STORE_DATA_CRAFTER_OUTPUT_VARIANTS;
